[
    {
        "id": 1,
        "name": "family",
        "children": [
            {
                "href": "fira/",
                "name": "Fira",
                "active": true
            },
            {
                "href": "minnas/",
                "name": "Dödsannonser",
                "active": false
            },
            {
                "href": "https://www.%scopeName.se/privatannons/",
                "name": "Boka annons"
            }
        ]
    },
    {
        "id": 2,
        "name": "jobs",
        "children": [
            {
                "href": "/",
                "name": "Jobb",
                "active": true
            },
            {
                "href": "https://medieportalen.%scopeName.se/rekrytering/",
                "name": "Boka annons"
            }
        ]
    },
    {
        "id": 3,
        "name": "market-guide",
        "children": [
            {
                "href": "/",
                "name": "Marknadsguiden",
                "active": true
            },
            {
                "href": "https://medieportalen.%scopeName.se/rekrytering/",
                "name": "Boka annons"
            }
        ]
    },
    {
        "id": 3,
        "name": "church-event",
        "children": [
            {
                "href": "/",
                "name": "Kyrkoevenemang",
                "active": true
            },
            {
                "href": "https://foretag-gota.cargoselfservice.com/",
                "name": "Boka annons"
            }
        ]
    }
]